<ng-container *ngIf="alert">
  <app-inset-text [color]="alert.type" [closable]="true" [removeBottomMargin]="true" (closed)="remove()">
    <span role="status">{{ alert.message }}</span>
  </app-inset-text>
</ng-container>
